import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'template'];
  static values = {
    index: Number
  };

  connect() {
    this.indexValue = parseInt(this.element.dataset.initialIndex || '0', 10);
    this.attachRemoveListeners();
  }

  addField(event) {
    event.preventDefault();
    const categoryId = event.currentTarget.dataset.categoryId;
    const container = this.element.querySelector(`.sub-hour-bank-templates-container[data-category-id="${categoryId}"]`);
    const template = this.element.querySelector(`template[data-category-id="${categoryId}"]`);

    if (!template || !container) {
      return;
    }

    const content = template.content.cloneNode(true);

    const inputs = content.querySelectorAll('input, select, textarea');

    inputs.forEach((input) => {
      if (input.name) {
        input.name = input.name.replace('__INDEX__', this.indexValue);
      }
      if (input.id) {
        input.id = input.id.replace('__INDEX__', this.indexValue);
      }
    });

    const orderInput = content.querySelector('input[name*="[order]"]');

    if (orderInput) {
      const existingFields = container.querySelectorAll('.sub-hour-bank-template-field:not([style*="display: none"])');

      orderInput.value = existingFields.length;
    }

    container.appendChild(content);
    this.indexValue++;
    this.attachRemoveListeners();
  }

  removeField(event) {
    event.preventDefault();
    const field = event.currentTarget.closest('.sub-hour-bank-template-field');

    if (!field) {
      return;
    }

    const idInput = field.querySelector('input[name*="[id]"]');

    if (idInput && idInput.value) {
      let destroyInput = field.querySelector('input[name*="[_destroy]"]');

      if (destroyInput) {
        destroyInput.value = '1';
      } else {
        destroyInput = document.createElement('input');
        destroyInput.type = 'hidden';
        destroyInput.name = idInput.name.replace('[id]', '[_destroy]');
        destroyInput.value = '1';
        field.appendChild(destroyInput);
      }
      field.style.display = 'none';
    } else {
      field.remove();
    }
  }

  attachRemoveListeners() {
    const removeButtons = this.element.querySelectorAll('.remove-sub-category-btn');

    // Create the bound function once before iterating
    if (!this.boundRemoveField) {
      this.boundRemoveField = this.removeField.bind(this);
    }

    removeButtons.forEach((btn) => {
      btn.removeEventListener('click', this.boundRemoveField);
      btn.addEventListener('click', this.boundRemoveField);
    });
  }
}
